//this.componentService.emitMessage("AnaUtentiComponent");

import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, Input, ComponentFactoryResolver, Type, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import * as Color from 'color';
import { ThemeService } from '../../services/theme.service';
import { DataService } from '../../services/data.service';
import { DxResponsiveBoxModule, DxListModule, DxTemplateModule, DxListComponent, DxFormComponent, DxRecurrenceEditorComponent, DxNumberBoxComponent } from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import notify from 'devextreme/ui/notify';
import DevExpress from 'devextreme';
import { GrigliaComponent } from '../../components/griglia/griglia.component';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Apiservice } from '../../services/api.service';
import { NgxSpinnerService } from "ngx-spinner";
import { Utenteservice } from '../../services/utente.service';
import { confirm } from 'devextreme/ui/dialog';
import { alert } from "devextreme/ui/dialog"
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { ComponentService } from '../../services/component.service';
import { MessaggioComponent } from '../../components/messaggio/messaggio.component';
import { messagefromComponent } from '../../class/appinterface';

import { ActivatedRoute, Router } from '@angular/router';
import { NicaAnagraficaComponent } from '../../components/nica-anagrafica/nica-anagrafica.component';
import { NicaFormComponent } from '../../components/nica-form/nica-form.component';
import { environment } from '../../../environments/environment';
import { Utente } from '../../class/userinterface';
import { type } from 'os';
import { NicaMaster } from '../../components/nica-master-component/nica-master.component';
import { FormsTemplateService } from '../../services/forms-template.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { AnagraficaService } from '../../services/anagrafica.service';
import { NewNicaFormComponent } from '../../components/nica-form/new-nica-form.component';
//import { setTimeout } from 'timers';



@Component({
  selector: 'app-ana-utenti',
  templateUrl: './ana-utenti.component.html',
  styleUrls: ['./ana-utenti.component.css'],
  providers: [DataService]
})
export class AnaUtentiComponent extends NicaMaster implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('componentGriglia', { static: false }) grigliaComponent: GrigliaComponent;
  @ViewChild('uUtenti', { static: false }) uUtenti: NicaAnagraficaComponent;

  @ViewChild('utentiForm', { static: false }) utentiForm: NewNicaFormComponent;

  @Output('onChiusuraUtentiEmitter') onChiusuraUtentiEmitter: EventEmitter<any> = new EventEmitter<any>();

  popupFormUtentiVisible?: boolean = false;

  showColumnLines = false;
  @Input() itemData: any
  showRentri = false;

  showRowLines = false;
  showBorders = false;
  rowAlternationEnabled = true;
  filterRow = true;
  //-------------
  pulsantiForm = [
    {
      location: "after",
      stylingMode: "text",
      widget:
        "dxButton",
      locateInMenu: "never",
      text: 'Salva',
      icon: "glyphicon mdi mdi-content-save-outline",
      event: 'salva',
      cssClass: 'salvaButton',
      class: 'salvaButton',
    },
    {
      location: "after",
      stylingMode: "text",
      widget: "dxButton",
      locateInMenu: "never",
      text: 'Annulla',
      icon: "glyphicon glyphicon icon-annulla-form",
      event: 'annulla',
      cssClass: 'escludiQuesto'
    },
  ];

  buttonInstance;
  dataSource: any;
  url: string;
  //------------
  dynamTitolo: string = "";
  queryString: string = '';
  params: any;
  showAppCaption: boolean = false;
  titleComponent: any;
  myService: string = 'utenti';
  titoloPopup?: string;

  /** Tipo Utente Loggato */
  tipoUtente?: number;

  /** Utente Selezionato per la Modifica */
  userSelected?: Utente | any;

  constructor(private http: HttpClient,
    _componentFactoryResolver: ComponentFactoryResolver,
    activatedroute: ActivatedRoute,
    userComponentService: ComponentService,
    private dataService: DataService,
    _overlaySideFormService: OverlaySideFormService,
    _overlaySidePanelService: OverlaySideFormService,
    private apiService: Apiservice,
    private spinner: NgxSpinnerService, private appService: Apiservice,
    public utenteService: Utenteservice,
    private themeService: ThemeService,
    formTemplateService: FormsTemplateService,
    router: Router,
    menuService: NicaMenuService,
    rentriService: RentriService,
    anagraficaService: AnagraficaService
  ) {
    super(userComponentService, formTemplateService, _overlaySideFormService, _overlaySidePanelService, formTemplateService, _componentFactoryResolver, activatedroute, router, menuService, rentriService, anagraficaService);
  }




  logga = (e: any) => {
    if (this._overlaySideFormService) this._overlaySideFormService.close();
    console.log(this);
  }

  onChiusuraUtenti(evt) {

    if (this.tipoUtente >= 3) {

      let event = { event: 5 };
      this.buttonEmitted(event);


    }
    else if (evt) {

      console.warn('sto chiudendo');
      this.onChiusuraUtentiEmitter.emit('chiudi');

    }



  }


  //onRowPrepared

  validatePrepared = (e: any) => {
    //alert("validate prepared","validat prepared"); 
    if (e.rowType == 'data') {
      var currentFirstName = e.component.cellValue(e.rowIndex, "firstName");
    }
  }

  optionalButtonClick2(e: any) {
    console.log("Button ", e);

    e.data = e.row.data;


    if (e.name == "InfousergruppiComponent") { //PermessiutentiComponent
      //tipo utente fino da 5 a 7
      if (e.data.tipoUtente < 5) {
        //alert("Per il tipo di utente i permessi sono associati dal sistema","Notifica");
        //return;
      }
      let data = [
        {
          idTabRif: e.data.id,
          titolo: "Gruppi di appartenza " + e.data.nomeCompleto,
          dati: e.data
        }
      ]

      /*const helpString = 'GestionePermessiutenti.html';//em.infoButton.name.replace(/\s/g, '')+'.html';
      const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
      const factoryClass = <Type<any>>factories.find((x: any) => x.name === e.name);
      this._overlaySideFormService.setTitle("Permessi per l'utente "+e.data.nomeCompleto);
      this._overlaySideFormService.setContent(factoryClass);
      this._overlaySideFormService.setToolBarVisible(true)
      this._overlaySideFormService.setHelp(helpString)
      this._overlaySideFormService.sendDataToComponent(data);
      this._overlaySideFormService.show();    */
      let id = "InfousergruppiComponent"
      this.userComponentService.setNewPopUp(id, 'InfousergruppiComponent', data, '500', null, null, true, true, "Gruppi di appartenza " + e.data.nomeCompleto)


      /*    const helpString = 'Gruppi.html';
          const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
          const factoryClass = <Type<any>>factories.find((x: any) => x.name === e.name);
          this._overlaySideFormService.setTitle("Gruppi di appartenza "+e.data.nomeCompleto);
          this._overlaySideFormService.setContent(factoryClass);
          this._overlaySideFormService.setToolBarVisible(true)
          this._overlaySideFormService.setHelp(helpString)
          this._overlaySideFormService.sendDataToComponent(data);    
          this._overlaySideFormService.show();
      */


    }


    if (e.name == "resetPwd") {
      if (e.data.guidAccettazione > "") {
        const result = confirm("Sei sicuro di voler reinviare invito  all'utente " + e.data.userName + " ?", "Reset Invito");
        result.then((dialogResult: any) => {
          if (!dialogResult) return;
          //ReinviaIscrizione RigeneraIscrizione
          this.appService.ReinviaIscrizione(e.data.userName).then(response => {
            if (response['codeMessage'] < 0) {
            } else {
              alert(response['descrMessage'], "Conferma Iscrizione")
              //this.step=1;
              return;
            }

          })
            .catch((err: HttpErrorResponse) => {
              this.appService.parseHttpErrorResponse(err);
            });
        })
      }
      else {

        const result = confirm("Sei sicuro di voler fare il reset password per l'utente " + e.data.userName + " ?", "Reset Password");
        result.then((dialogResult: any) => {
          if (!dialogResult) return;
          //this.utenteService.InfoUtenteConnesso.userName
          this.appService.RecuperaPassword(e.data.userName).then(response => {
            if (response['codeMessage'] < 0) {
              //this.ErrMessage=response['message'];

            } else {
              alert(response['descrMessage'], "Reset Password")
              //this.step=1;
              return;
            }

          })
            .catch((err: HttpErrorResponse) => {
              this.appService.parseHttpErrorResponse(err);
            });
        });
      }
    }
  }
  onUserSelected(e: any) {
    //alert("Selezionato Padre","Selezionato record su gliglia");
  }
  validateDataFieldPrepared = (e: any) => {
    //alert("before edit","before edit");
    console.log('DataFieldPrepared', e);
  }

  validateEdit = (e: any) => {
    //alert("before edit","before edit");
    //console.log('beforeEditxxx',e);
  }



  async onAllEventUtenti(evt: any) {
    //console.log("ecco AllEvent ",evt);
    //console.warn(evt.name);
    //onSaving
    if (evt.name == "onSaving") {
      console.log("ecco AllEvent ", evt);
      evt.result = false;
    }

    if (evt.name == "InfousergruppiComponent") {
      if (evt.row.data.tipoUtente == 8) {
        (evt.cellElement as HTMLElement).innerHTML = ""
      }
    }
    if (evt.name == 'onCellPrepared') {

      //onCellPrepared
      //console.log("ecco onCellPrepared ",evt);
      if (evt.rowType === 'data') {
        if (evt.column.type == 'buttons' && evt.column.buttons[0].name == 'InfousergruppiComponent') {
          //alert("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee",'w')
          //console.log("ecco onCellPrepared ",evt);
          if (evt.data.tipoUtente > 7)
            (evt.cellElement as HTMLElement).innerHTML = '';

        }


        if (evt.column.dataField == "guidAccettazione") {
          if (evt.value > "") {


            (evt.cellElement as HTMLElement).title = "In Attesa di Invito";
            (evt.cellElement as HTMLElement).setAttribute('style', "width: 14px;height: 14px;background-position: 0 0;background-size: 14px 14px;font-size: 14px;text-align: center;line-height: 14px;margin: 0 1px;");
            (evt.cellElement as HTMLElement).innerHTML = '<i style="color:red;text-align:center" class="mdi mdi-close-circle-outline error"></i>';  //'<img width="32px" title="In attesa di accettazione" src="https://img.icons8.com/external-parzival-1997-flat-parzival-1997/64/000000/external-no-touch-touchless-society-parzival-1997-flat-parzival-1997-1.png"/>';



          }
          else {



            (evt.cellElement as HTMLElement).title = "Invitato";
            (evt.cellElement as HTMLElement).setAttribute('style', "width: 14px;height: 14px;background-position: 0 0;background-size: 14px 14px;font-size: 14px;text-align: center;line-height: 14px;margin: 0 1px;");
            (evt.cellElement as HTMLElement).innerHTML = '<i style="color:green;text-align:center" class="mdi mdi-checkbox-marked-circle-outline"></i>';    //'<img width="32px" title="Accettata iscrizione" src="https://img.icons8.com/color/48/000000/checked--v1.png"/>';




          }
          //e.cellElement.innerHTML="<p style='color:red;font-weight: 900;'>In Attesa</p>";
        }


      }



      if (this.utenteService.DammiTipoUtente() == 1) {

        if (this.uUtenti.griglia.instance.getVisibleRows().length >= 1) {

          // if (document.getElementsByClassName("dx-datagrid-addrow-button").item(document.getElementsByClassName("dx-datagrid-addrow-button").length - 1).parentElement.parentElement)
          //   document.getElementsByClassName("dx-datagrid-addrow-button").item(document.getElementsByClassName("dx-datagrid-addrow-button").length - 1).parentElement.parentElement.classList.add('dx-state-disabled');   //="dx-item dx-toolbar-item dx-toolbar-button dx-toolbar-item-auto-hide dx-state-disabled";

        }
        else {

          if (document.getElementsByClassName("dx-datagrid-addrow-button").item(document.getElementsByClassName("dx-datagrid-addrow-button").length - 1).parentElement.parentElement)
            document.getElementsByClassName("dx-datagrid-addrow-button").item(document.getElementsByClassName("dx-datagrid-addrow-button").length - 1).parentElement.parentElement.classList.remove('dx-state-disabled');   //="dx-item dx-toolbar-item dx-toolbar-button dx-toolbar-item-auto-hide dx-state-disabled";


        }
      }


      /*
          dx-datagrid-toolbar-button dx-edit-button dx-datagrid-addrow-button dx-button dx-button-normal dx-button-mode-contained dx-widget my-class-buttonAdd-grid dx-button-has-icon dx-button-has-textì
      */



    }


    if (evt == 'RowRemoving') {



      if (this.utenteService.DammiTipoUtente() == 1) {


        setTimeout
          (
            () => {
              if (document.getElementsByClassName("dx-datagrid-addrow-button").item(document.getElementsByClassName("dx-datagrid-addrow-button").length - 1).parentElement.parentElement && this.uUtenti.griglia.instance.getVisibleRows().length < 1)
                document.getElementsByClassName("dx-datagrid-addrow-button").item(document.getElementsByClassName("dx-datagrid-addrow-button").length - 1).parentElement.parentElement.classList.remove('dx-state-disabled');
            }, 2000
          );


      }

    }

    /*
    if(evt == 'RowRemoving'){

      if(this.utenteService.DammiTipoUtente() == 1){

        console.warn(this.uUtenti.griglia.instance.getVisibleRows());
  
  
        if(document.getElementsByClassName("dx-datagrid-addrow-button").item(document.getElementsByClassName("dx-datagrid-addrow-button").length-1).parentElement.parentElement &&  this.uUtenti.griglia.instance.getVisibleRows().length<1)
          document.getElementsByClassName("dx-datagrid-addrow-button").item(document.getElementsByClassName("dx-datagrid-addrow-button").length-1).parentElement.parentElement.classList.remove('dx-state-disabled');
  
        }

    }
    */

    if (evt.name == "onEditorPreparing") {
      //evt.cancel = true;


    }


    /*
    setTimeout(
      ()=>{

        this.dataGridStrutture.griglia.columns[0]['buttons'][0].name = 'copy';

      },5000
    )*/

    //this.pannelloExcelExporterVisibile = true;



    //All'aggiunta di un nuovo modello
    if (evt.name == "onInitNewRow") {

      evt.cancel = true;

      this.userSelected = undefined;

      this.titoloPopup = 'Creazione Nuovo Utente';

      this.popupFormUtentiVisible = true;

      if (this.showRentri === true) {
        setTimeout(() => {
          this.utentiForm.dataSet['tipoUtente'] = 6
          $("#tipoAttivita").hide();
          this.utentiForm.itemOption("tipoAttivita", "visible", false);
          this.utentiForm.itemOption('datiUtente.tipoUtente', 'disabled', true);
        }, 400);

      }


    }
    if (evt.name == "onEditorPrepared") { //Modifica utente esistente

      evt.cancel = true;


      this.spinner.show();

      try {

        let userData = await this.http.get<Utente>(environment.BASE_API_URL.concat(`Account/${evt.data.id}`)).toPromise();


        if (!userData) {
          this.spinner.hide();
          return;
        }


        this.userSelected = userData;

        this.titoloPopup = `Modifica Utente: `.concat(this.userSelected.userName);

        this.popupFormUtentiVisible = true;


        if (this.showRentri === true) {
          setTimeout(() => {
            //this.utentiForm.dataSet['tipoUtente']=6
            $("#tipoAttivita").hide();
            //this.utentiForm.itemOption('datiUtente.tipoUtente','disabled',true); 
          }, 400);

        }



      } catch (ex) {

        this.titoloPopup = undefined;
        this.spinner.hide();

      }

    }


    if (evt.name == 'onRowClickLookUp') {
      if (evt.dataField == "utenteRif") {
        console.log(" onRowClickLookUp ", evt)
        evt.masterThis.settaField('userName', evt.rowData['userName']);
        evt.masterThis.settaField('telefono', evt.rowData['telefono']);
        evt.masterThis.settaField('nomeCompleto', evt.rowData['nomeCompleto']);
        evt.masterThis.settaField('tipoUtente', evt.rowData['tipoUtente']);
        evt.masterThis.settaField('emailRecupero', evt.rowData['emailRecupero']);
        evt.masterThis.settaField('emailComunicazioni', evt.rowData['emailComunicazioni']);
        evt.masterThis.settaField('sospeso', evt.rowData['sospeso']);
        //e.masterThis.settaField('scadenzaAccount',e.rowData['scadenzaAccount']);
        setTimeout(() => {

          evt.masterThis.changeStateField(['codiceFiscale', 'userName', 'telefono', 'nomeCompleto', 'tipoUtente', 'emailRecupero', 'emailComunicazioni', 'sospeso', 'scadenzaAccount'], true)
          //e.masterThis.changeStateField(['userName'],true)

        }, 500);
      }
    }
  }

  async gestisciEventoForm(evt: any) {

    if (typeof evt == 'object') {
      console.log("In Form ", evt.name)

      switch (evt.name) {
        case "beforSave": {
          //console.log("In Form ",evt)
          if (evt.formData.tipoUtente == 6) {
            if (evt.formData.codiceFiscale == '') {
              alert("Per tipo utente selezionato, il codice fiscale è obbligatorio e fa riferimento all'azienda a cui si vuole associare", "Attenzione");
              evt.cancella = true;
            }
          }
          break;
        }
        case "selectedItemLista": {

          if (evt.campo.dataField == 'importaUtente') {

            if (typeof evt.value == 'undefined')
              return;

            let utenteSelezionato: Utente = await this.http.get<any>(environment.BASE_API_URL.concat(`Account/${evt.value}`)).toPromise();

            if (!utenteSelezionato)
              return;

            this.utentiForm.formRefreshInputData('nomeCompleto', utenteSelezionato.nomeCompleto);
            this.utentiForm.formRefreshInputData('emailRecupero', utenteSelezionato.emailRecupero);
            this.utentiForm.formRefreshInputData('emailComunicazioni', utenteSelezionato.emailComunicazioni);
            this.utentiForm.formRefreshInputData('telefono', utenteSelezionato.telefono);
            this.utentiForm.formRefreshInputData('scadenzaAccount', utenteSelezionato.scadenzaAccount);

            //this.utentiForm.itemOption('datiUtente', 'label', 'cambio label');

          }


          if (evt.campo.dataField == 'tipoUtente') {

            //Controllo tipo attività UTENTI APP
            if (evt.value == 8) {
              this.utentiForm.itemOption('tipoAttivita.firmaRentriAutista', 'disabled', false);
              this.utentiForm.itemOption('tipoAttivita.firmaRentriProduttore', 'disabled', false);
              this.utentiForm.itemOption('tipoAttivita.firmaRentriSmaltitore', 'disabled', false);
              this.utentiForm.itemOption('tipoAttivita.firmaRentriConsulente', 'disabled', false);
              this.utentiForm.itemOption('tipoAttivita.firmaRentriIntermediario', 'disabled', false);
              this.utentiForm.itemOption('tipoAttivita.firmaRentriAssociazione', 'disabled', false);


            } else {

              this.utentiForm.itemOption('tipoAttivita.firmaRentriAutista', 'disabled', true);
              this.utentiForm.formRefreshInputData('tipoAttivita.firmaRentriAutista', false)


              this.utentiForm.itemOption('tipoAttivita.firmaRentriProduttore', 'disabled', true);
              this.utentiForm.formRefreshInputData('firmaRentriProduttore', false)



              this.utentiForm.itemOption('tipoAttivita.firmaRentriSmaltitore', 'disabled', true);

              this.utentiForm.formRefreshInputData('firmaRentriSmaltitore', false);

              this.utentiForm.itemOption('tipoAttivita.firmaRentriConsulente', 'disabled', true);

              this.utentiForm.formRefreshInputData('firmaRentriConsulente', false);

              this.utentiForm.itemOption('tipoAttivita.firmaRentriIntermediario', 'disabled', true);

              this.utentiForm.formRefreshInputData('firmaRentriIntermediario', false);

              this.utentiForm.itemOption('tipoAttivita.firmaRentriAssociazione', 'disabled', true);
              this.utentiForm.formRefreshInputData('value', false);
              if (evt.value == 6) {
                this.utentiForm.itemOption('datiUtente.codiceFiscale', 'setLabel', 'Codice Fiscale Azienda');
                this.utentiForm.itemOption('datiUtente.codiceFiscale', 'setValidators', [{ message: "Il Campo è Obbligatorio", type: "required" }]);


              } else {
                this.utentiForm.itemOption('datiUtente.codiceFiscale', 'setLabel', 'Codice Fiscale');
                this.utentiForm.itemOption('datiUtente.codiceFiscale', 'validationRules', null);
              }


              //form.masterComponent.itemOption('datiUtente.codiceFiscale', 'label', 'cambio label');

            }

            //I vari API e API Esterni Users non devono mai poter né essere sospesi né scadere
            if (evt.value == 7 || evt.value == 9) {

              this.utentiForm.itemOption('datiUtente.scadenzaAccount', 'disabled', true);
              this.utentiForm.itemOption('datiUtente.sospeso', 'disabled', true);
              this.utentiForm.formRefreshInputData('scadenzaAccount', undefined);
              this.utentiForm.formRefreshInputData('sospeso', false);


            }
            else {

              this.utentiForm.itemOption('datiUtente.scadenzaAccount', 'disabled', false);
              this.utentiForm.itemOption('datiUtente.sospeso', 'disabled', false);


            }

          }

        }


      }

    }




    switch (evt.name) {

      case 'return': {

        this.popupFormUtentiVisible = false;

      } break;

      case "submitFormStatic": {

        if (!this.utentiForm.validate().isValid)
          return;

        if (this.utentiForm.dataSet['tipoUtente'] == 8 &&
          (!this.utentiForm.dataSet['firmaRentriAutista'] &&
            !this.utentiForm.dataSet['firmaRentriProduttore'] &&
            !this.utentiForm.dataSet['firmaRentriSmaltitore'] &&
            !this.utentiForm.dataSet['firmaRentriConsulente'] &&
            !this.utentiForm.dataSet['firmaRentriIntermediario'] &&
            !this.utentiForm.dataSet['firmaRentriAssociazione']
          )) {


          alert("Si prega di selezionare un tipo di attività per questo utente", "Attenzione");

          return;
        }

        //Per capire se dobbiam fare la post oppure la put possiamo andare a vedere se abbiamo un id gia pronto e se il nostro userSelected non è undefined

        let body = {
          userName: this.utentiForm.dataSet['userName'],
          tipoUtente: this.utentiForm.dataSet['tipoUtente'],
          nomeCompleto: this.utentiForm.dataSet['nomeCompleto'],
          codiceFiscale: this.utentiForm.dataSet['codiceFiscale'],
          telefono: this.utentiForm.dataSet['telefono'],
          emailRecupero: this.utentiForm.dataSet['emailRecupero'],
          emailComunicazioni: this.utentiForm.dataSet['emailComunicazioni'],
          sospeso: this.utentiForm.dataSet['sospeso'],
          scadenzaAccount: this.utentiForm.dataSet['scadenzaAccount'],
          firmaRentriAutista: this.utentiForm.dataSet['firmaRentriAutista'],
          firmaRentriProduttore: this.utentiForm.dataSet['firmaRentriProduttore'],
          firmaRentriSmaltitore: this.utentiForm.dataSet['firmaRentriSmaltitore'],
          firmaRentriConsulente: this.utentiForm.dataSet['firmaRentriConsulente'],
          firmaRentriIntermediario: this.utentiForm.dataSet['firmaRentriIntermediario'],
          firmaRentriAssociazione: this.utentiForm.dataSet['firmaRentriAssociazione'],
          nome: this.utentiForm.dataSet['nome'],
          cognome: this.utentiForm.dataSet['cognome'],
        };

        if (this.userSelected) {
          if (this.userSelected.id) {

            body['id'] = this.userSelected.id;


            try {


              let ris = await this.http.put(environment.BASE_API_URL.concat('Account/' + this.userSelected.id), body).toPromise();


              if (ris) {


                notify({
                  message: 'Utente modificato con successo',
                  height: 45,
                  width: 250,
                  position: 'center center'
                }, 'success', 3000);


                this.popupFormUtentiVisible = false;

                this.titoloPopup = undefined;

                this.uUtenti.griglia.instance.refresh();
              }


            } catch (ex) {



            }




          }
        } else { //In caso stessi facendo una post

          if (body['id'])
            delete body['id'];


          try {

            let ris: any;

            if (this.tipoUtente == 3 && (body.tipoUtente == 4 || body.tipoUtente == 5)) //|| body.tipoUtente == 6
              ris = await this.http.post(environment.BASE_API_URL.concat('Account/CreateAdvancedOrStandardUser'), body).toPromise();
            else
              ris = await this.http.post(environment.BASE_API_URL.concat('Account'), body).toPromise();

            if (ris) {


              notify({
                message: 'Utente aggiunto con successo',
                height: 45,
                width: 250,
                position: 'center center'
              }, 'success', 3000);


              this.popupFormUtentiVisible = false;

              this.titoloPopup = undefined;

              this.uUtenti.griglia.instance.refresh();
            }


          } catch (ex) {



          }


        }




      } break;


    }






  }

  initFormEvent(evt) {
    if (this.userSelected) {


      evt.component.itemOption('datiUtenteAsOwner.userName', 'disabled', true);


      if (this.userSelected.tipoUtente == 8) {
        evt.component.itemOption('tipoAttivita.firmaRentriProduttore', 'disabled', false);
        evt.component.itemOption('tipoAttivita.firmaRentriAutista', 'disabled', false);
        evt.component.itemOption('tipoAttivita.firmaRentriSmaltitore', 'disabled', false);
        evt.component.itemOption('tipoAttivita.firmaRentriConsulente', 'disabled', false);
        evt.component.itemOption('tipoAttivita.firmaRentriIntermediario', 'disabled', false);
        evt.component.itemOption('tipoAttivita.firmaRentriAssociazione', 'disabled', false);
      } else
      // if(this.userSelected.tipoUtente !== 8 )
      {
        evt.component.itemOption('tipoAttivita.firmaRentriProduttore', 'disabled', true);
        evt.component.itemOption('tipoAttivita.firmaRentriAutista', 'disabled', true);
        evt.component.itemOption('tipoAttivita.firmaRentriSmaltitore', 'disabled', true);
        evt.component.itemOption('tipoAttivita.firmaRentriConsulente', 'disabled', true);
        evt.component.itemOption('tipoAttivita.firmaRentriIntermediario', 'disabled', true);
        evt.component.itemOption('tipoAttivita.firmaRentriAssociazione', 'disabled', true);

      }

    }




    let form = evt.component;
    const editorTipoUtente = form.getInputsComponents('tipoUtente').component;

    //console.log('editorTipoUtente-->',editorTipoUtente)




    switch (this.tipoUtente) {

      case 1: {

        form.formRefreshInputData('tipoUtente', 2);
        form.itemOption('datiUtente.tipoUtente', 'disabled', true);


      } break;

      case 2: {

        editorTipoUtente.optionData = editorTipoUtente.optionData.filter(option => {
          return option.id == 3 || option.id == 7 || option.id == 9
        })
        form.formRefreshInputData('tipoUtente', 3);

        form.itemOption('datiUtente.tipoAttivita', 'cssClass', 'd-none');

        if (this.userSelected)
          form.itemOption('datiUtente.tipoUtente', 'disabled', true);

      } break;

      case 3: {

        editorTipoUtente.optionData = editorTipoUtente.optionData.filter(option => {
          return option.id == 4 || option.id == 5 || option.id == 6 || option.id == 8 || option.id == 10 || option.id == 11
        }
        );

        if (this.userSelected)
          form.itemOption('datiUtente.tipoUtente', 'disabled', true);


      } break;


    }

    if (!this.userSelected) //se non sono in modifica utente return
      return;




    this.utentiForm.formRefreshInputData('tipoUtente', this.userSelected.tipoUtente);
    //editorTipoUtente.option('value',this.userSelected.idtipoutente);
    this.utentiForm.formRefreshInputData('telefono', this.userSelected.telefono);
    this.utentiForm.formRefreshInputData('emailRecupero', this.userSelected.emailRecupero);
    this.utentiForm.formRefreshInputData('emailComunicazioni', this.userSelected.emailComunicazioni);
    this.utentiForm.formRefreshInputData('userName', this.userSelected.userName);
    this.utentiForm.formRefreshInputData('nomeCompleto', this.userSelected.nomeCompleto);
    this.utentiForm.formRefreshInputData('codiceFiscale', this.userSelected.codiceFiscale);
    this.utentiForm.formRefreshInputData('scadenzaAccount', this.userSelected.scadenzaAccount);
    this.utentiForm.formRefreshInputData('sospeso', this.userSelected.sospeso);
    if (this.userSelected.nome) this.utentiForm.formRefreshInputData('nome', this.userSelected.nome);
    if (this.userSelected.cognome) this.utentiForm.formRefreshInputData('cognome', this.userSelected.cognome);

    //Se utente App
    if (this.userSelected.tipoUtente == 8) {
      this.utentiForm.formRefreshInputData('firmaRentriAutista', this.userSelected.firmaRentriAutista);
      this.utentiForm.formRefreshInputData('firmaRentriProduttore', this.userSelected.firmaRentriProduttore);
      this.utentiForm.formRefreshInputData('firmaRentriSmaltitore', this.userSelected.firmaRentriSmaltitore);
      this.utentiForm.formRefreshInputData('firmaRentriConsulente', this.userSelected.firmaRentriConsulente);
      this.utentiForm.formRefreshInputData('firmaRentriIntermediario', this.userSelected.firmaRentriIntermediario);
      this.utentiForm.formRefreshInputData('firmaRentriAssociazione', this.userSelected.firmaRentriAssociazione);
    }

    //editorTipoUtente.option('disabled',true);

    // this.spinner.hide();


  }


  //viene richiamata prima delle modifica o creazione del record
  validateData = (e: any) => {
    console.log("Ecco eventovalidateData ", e);
    //e.newData.telefono="123456789" 
    //eventuali cambiamenti in new data vengono registrati solo se isValid=true !! per il momento
    //e.isValid=true   
    //e.errorText="";
    //console.log("Ecco evento dopo",e);
    //return e;
  }


  ngOnDestroy(): void {
    //throw new Error('Method not implemented.');
  }

  ngAfterViewInit() {
    // this.grigliaComponent.grid.instance.option("rowAlternationEnabled",this.rowAlternationEnabled);
    if (environment.SHOW_RENTRI === true) {
      this.uUtenti.griglia.instance.columnOption("firmaRentriAutista", 'visible', false)
      this.uUtenti.griglia.instance.columnOption("firmaRentriProduttore", 'visible', false)
      this.uUtenti.griglia.instance.columnOption("firmaRentriSmaltitore", 'visible', false)
      this.uUtenti.griglia.instance.columnOption("firmaRentriConsulente", 'visible', false)
      this.uUtenti.griglia.instance.columnOption("firmaRentriIntermediario", 'visible', false)
      this.uUtenti.griglia.instance.columnOption("firmaRentriAssociazione", 'visible', false)

    }







    /*
    const instance = this.dataGrid.instance;  // Ottieni l'istanza del data grid
        const currentVisibility = instance.columnOption(field, 'visible');
        instance.columnOption(field, 'visible', !currentVisibility);
      }
    */

    //$("#gridContainer").dxDataGrid("instance").columnOption("address", "visible", false);

  }
  ngOnInit() {



    if (this.itemData) {
      this.dynamTitolo = this.itemData['titolo'];
      this.myService = this.itemData['serivce'];
    }

    this.tipoUtente = this.utenteService.DammiTipoUtente();
    //this.myService='AccountNoAuth'


    if (this.itemData != undefined) {

      this.setGlobalVariable(this.itemData);




    } else {
      //console.log('url',this.router.url)
      this.activatedroute.queryParams
        .subscribe(params => {
          this.currentTabId = params.currentTabId,
            this.currentTabName = params.currentTabName


          this.showToolBar = false//Per ora ...

          this.setGlobalVariableFromParams(params);

          this.params = JSON.parse(params.data)
          //Setto le valiabili in base ai paramentri passati nella url


          this.queryString = '?idLicenza=' + this.params.idLicenza;
          this.showAppCaption = true;
          this.titleComponent = this.params.titolo;


        });
    }
  }



  onShowing(e: any) {


    e.component.content().parentNode.classList.add("bg-grey"); //add class to overlay content
    e.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
    //e.component.content().parentNode.classList.add("popup"); //add class to overlay content
    e.component.content().classList.add("soggetto-form"); //add class to content

    //e.component.content().classList.add("formEditAna"); //add class to content



  }

  onHiding(e: any) {

    if (this.utentiForm)
      this.utentiForm.dataSet = [];

    this.titoloPopup = undefined;
  }


  setGlobalVariable(itemData) {

    try {

      this.apiset = itemData[0].apiset;
      this.id = itemData[0].id;
      this.queryString = itemData[0].queryString
      this.rowData = itemData[0].dati
      this.template = itemData[0].template
      this.masterKey = itemData[0].masterKey
      this.type = itemData[0].tipo
      this.SubjectCall = itemData[0].SubjectCall;
      this.InviaA = itemData[0].inviaA;
      this.toolbarComponentFilter = itemData[0].toolbarComponent

    } catch (err) {

      console.warn(err);
    }
  }



  setGlobalVariableFromParams(routerParam) {

    this.menuService.previousUrl$.subscribe(prevUrl => {

      this.returnUrl = prevUrl
    })


    this.params = routerParam



    console.log('routerParam-->', routerParam)

    this.previusUrl = routerParam.prevUrl

    this.anagraficaDati = this.templateService.getService(routerParam.service);

    if (!this.anagraficaDati) {
      if (routerParam.service) {
        this.SubjectCall = routerParam.service
      }

      return
    }
    /**Setto le Variabili globali dalla conFigurazione dell'anagrafica***/

    const anagraficaFilter = this.anagraficaDati.filter(r => r.configuration);
    this.apiset = anagraficaFilter[0]['configuration']['api'];
    this.SubjectCall = anagraficaFilter[0]['configuration']['service']
    this.type = anagraficaFilter[0]['configuration']['formType'];
    this.nCol = anagraficaFilter[0]['configuration']['nCol'];

    this.allowedAdvancedFilter = anagraficaFilter[0]['configuration']['allowedAdvancedFilter'];
    this.advancedXlsExportFilterTemplateName = anagraficaFilter[0]['configuration']['advancedXlsExportFilterTemplateName'];
    this.isAdvancedXlsExportAvailable = anagraficaFilter[0]['configuration']['isAdvancedXlsExportAvailable'];

    /* Ottengo in nome del servizio legato alla toolbar */
    this.toolbarComponentFilter = anagraficaFilter[0]['configuration']['toolbarSettings'];

    /*
       Ottengo in nome del servizio legato alla Tipo di template dai paramenti,se non è settato utilizzo quello della configurazione 
       presente nell'anagrafica.
     */


    if (routerParam.templateView) {
      this.template = routerParam.templateView;

    } else {
      this.template = this.anagraficaDati[0]['configuration']['template']
    }


    /* Ottengo l'oggetto contente i bottoni della toobar */
    if (typeof this.toolbarComponentFilter != 'undefined') {

      this.serviceButtonsArray = this.anagraficaService.getService(this.toolbarComponentFilter.service);
    }


    /* Setto i filtri globali che arrivano dali paramentri */

    if (routerParam.filter) {
      this.filterID = JSON.parse(routerParam.filter);
    }



    if (routerParam.id) {

      this.id = routerParam.id

    }

    /* 
  
      Se il template è di tipo Griglia o gli dynamicgrid costrusco i paramentri path o qstring per ottenere l'elenco/lista dei dati
      via API 
  
    */


    if (this.template == 'grid' || this.template == 'dynamicGrid') {
      let filterList = anagraficaFilter[0]['configuration']['filterList'];

      if (filterList.includes('&')) {
        let arrayfilterList = filterList.split('&');
        arrayfilterList.forEach(arr => {
          if (arr.includes('$')) {
            const arrayFilterList = arr.split('$');

            arrayFilterList.forEach(keyRif => {
              keyRif = keyRif.includes('?') ? keyRif.replace('?', '') : keyRif;
              if (this.filterID[keyRif]) {
                let data = this.filterID[keyRif];
                filterList = filterList.replace('$' + keyRif, data);
              }
            })

            this.filterGrid = filterList;

          }
        })
      } else {

        let regExp = /\(([^)]+)\)/;
        let matches = regExp.exec(filterList);

        //matches[1] contains the value between the parentheses
        if (matches) {
          if (matches[1].includes('$')) {
            const arrayFilterList = matches[1].split('$');

            //let arrayIdRif = anagraficaFilter[0]['configuration']['idTabRif']
            arrayFilterList.forEach(keyRif => {
              ////console.log(keyRif)
              if (this.filterID[keyRif]) {
                let data = this.filterID[keyRif];

                try {
                  filterList = filterList.replace('$' + keyRif, data);
                } catch (error) {
                  console.error('ERRORE: ', error)
                  //console.log('FilterID: ', this.filterID)
                }



              }
            })
          }
        } else {
          if (filterList.includes('$')) {
            const arrayFilterList = filterList.split('$');

            //let arrayIdRif = anagraficaFilter[0]['configuration']['idTabRif']
            arrayFilterList.forEach(keyRif => {
              ////console.log(keyRif)
              if (this.filterID[keyRif]) {
                let data = this.filterID[keyRif];

                try {
                  filterList = filterList.replace('$' + keyRif, data);
                } catch (error) {
                  console.error('ERRORE: ', error)
                  //console.log('FilterID: ', this.filterID)
                }



              }
            })



          }
        }
        this.filterGrid = filterList;

      }





      if (routerParam.queryFilter) {
        if (anagraficaFilter[0]['configuration']['queryFilter']) {
          let arrayQueryFilter = anagraficaFilter[0]['configuration']['queryFilter']

          let newItemQ = ''
          let dataQueryFilter = JSON.parse(routerParam.queryFilter)

          arrayQueryFilter.forEach(idTab => {
            if (typeof dataQueryFilter[idTab['key']] != 'undefined') {
              newItemQ += idTab['key'] + '=' + dataQueryFilter[idTab['key']] + '&';

              //////console.log(idTab['key'] + '=' + dataQueryFilter[idTab['key']])
            }
          });



          if (newItemQ) {
            this.filterGrid = '?' + newItemQ
          }
        }

      }

      /**************************Definizione TItolo Griglia******************************/


      let descEvent = routerParam.descEvent ? routerParam.descEvent : '';
      let keysTitleDaPortare = []
      if (anagraficaFilter[0]['configuration']['campoTitle']) {
        keysTitleDaPortare = anagraficaFilter[0]['configuration']['campoTitle'];
      }

      let titleGriglia = anagraficaFilter[0]['configuration']['titleGriglia']

      keysTitleDaPortare.forEach(keyTitleDaPortare => {
        if (this.filterID[keyTitleDaPortare]) {
          let data = this.filterID[keyTitleDaPortare];;
          let dateType = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
          let isMatch = dateType.test(data);

          if (isMatch) {
            let date = new Date(data)
            let month = date.getMonth();
            month = month + 1
            let day = date.getDate().toString().padStart(2, '0');
            data = day + '-' + month + '-' + date.getFullYear()
          }

          if (titleGriglia.includes(keyTitleDaPortare)) {
            titleGriglia = titleGriglia.replace(keyTitleDaPortare, data)
          }

          //titleGriglia = titleGriglia.replace(keyTitleDaPortare, data)
        }
      })

      this.titleDynamic = titleGriglia;

      if (this.template == 'dynamicGrid') {

        this.setVariableDynamicGrid();
        //this.SetToolbarButtons();
      }

      this.filterID['isEdit'] = false

      /*******************************************************/
    } else {

      let filterEditor = anagraficaFilter[0]['configuration']['filterEditor'];

      if (filterEditor.includes('$')) {

        if (this.id != '' && typeof this.id != 'undefined') {
          this.queryString = filterEditor.replace('$', this.id)
        }
      }
    }


    this.masterKey = anagraficaFilter[0]['configuration']['masterKey'];

    if (anagraficaFilter[0]['configuration']['helpDoc']) {

      this.helpDoc = anagraficaFilter[0]['configuration']['helpDoc']


    }


    /*
      Se il template è di tipo form, ottengo i dati 
    */

    if (this.template == 'form' || this.template == 'component') {

      let descEvent = routerParam.descEvent ? routerParam.descEvent : ''
      let keysTitleDaPortare = anagraficaFilter[0]['configuration']['campoTitle'] ? anagraficaFilter[0]['configuration']['campoTitle'] : [];

      let titleDaPortare = '';

      let titleForm = anagraficaFilter[0]['configuration']['titleForm']

      keysTitleDaPortare.forEach(keyTitleDaPortare => {
        if (this.filterID[keyTitleDaPortare]) {
          let data = this.filterID[keyTitleDaPortare];;
          let dateType = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
          let isMatch = dateType.test(data);

          if (isMatch) {
            let date = new Date(data)
            let month = date.getMonth();
            month = month + 1
            let day = date.getDate().toString().padStart(2, '0');
            data = day + '-' + month + '-' + date.getFullYear()
          }


          titleForm = titleForm.replace(keyTitleDaPortare, data)
        } else {
          titleForm = titleForm.replace(keyTitleDaPortare, '')
        }
      })

      this.titleDynamic = titleForm;


      if (typeof this.id == 'undefined' || this.id == '') {
        //console.log('SetToolbarButtons', this.serviceButtonsArray)
        //this.SetToolbarButtons()
      }

    }

    if (routerParam.breadcrumb) {
      this.breadcrumbCaption = routerParam.breadcrumb
    } else {
      this.breadcrumbCaption = anagraficaFilter[0]['configuration']['breadcrumbCaption'];
      this.idBreadcrumbGroup = anagraficaFilter[0]['configuration']['idBreadcrumbGroup'];
    }

    //Costrusco i dati costanti da inviare alla form.

    let data
    if (routerParam.filter) {

      data = JSON.parse(routerParam.filter);
      //console.log('routerParamData', data)
      if (anagraficaFilter[0]['configuration']['idTabRif']) {
        let arrayIdRif = anagraficaFilter[0]['configuration']['idTabRif']

        arrayIdRif.forEach(idTab => {
          if (typeof data[idTab['value']] != 'undefined') {
            this.rowData[idTab['key']] = data[idTab['value']];
          }


        });

      }


    }

    if (routerParam.queryFilter) {

      this.queryFilter = JSON.parse(routerParam.queryFilter);

    }

    let navComponent = sessionStorage.getItem('navComponent')

    if (navComponent) {

      this.cronNavigation = JSON.parse(navComponent);
      this.userComponentService.setNavComponent(this.cronNavigation)

    }

    this.userComponentService.componentRouter.forEach(res => {

      if (Array.isArray(res) && res.length > 0) {
        this.cronNavigation = res.filter(res => res.idTab == routerParam.currentTabId)
      }


    })

    if (this.cronNavigation.length > 0) {
      let navigations = this.cronNavigation.filter(res => res.idTab == this.currentTabId)
      let navigation = navigations[0].data;

      let checkItemIdex = navigation.findIndex(n => n.id == this.idBreadcrumbGroup);


      if (checkItemIdex == -1) {

        let nav = {
          title: this.breadcrumbCaption,
          cRouter: this.router.url.split('?')[0],
          params: this.params,
          idGroup: this.idBreadcrumbGroup,
          idTab: this.currentTabId,
          idData: this.SubjectCall,
          active: true,

        }
        this.userComponentService.setComponentNavigation(nav);
      } else {


        let itemDataNav = {
          title: this.breadcrumbCaption,
          cRouter: this.router.url.split('?')[0],
          params: this.params,
          idGroup: this.idBreadcrumbGroup,
          idTab: this.currentTabId,
          idData: this.SubjectCall,
          active: true,

        }
        this.userComponentService.setNavigationChildren(itemDataNav, this.idBreadcrumbGroup);
      }

    } else {

      let nav = {
        title: this.breadcrumbCaption,
        cRouter: this.router.url.split('?')[0],
        params: this.params,
        idGroup: this.idBreadcrumbGroup,
        idTab: this.currentTabId,
        idData: this.SubjectCall,
        active: true,
        items: []
      }



      this.userComponentService.setComponentNavigation(nav)
    }

    let navigationData = []


    const navigationsFilter = this.cronNavigation.filter(res => res.idTab == this.currentTabId)
    if (navigationsFilter.length > 0) {
      let navigationData = navigationsFilter[0].data;

      this.breadcrumbNavigation = navigationData;

      console.log('breadcrumbNavigation', this.breadcrumbNavigation)
      this.tabNavigationChildrend = navigationData.filter(res => res.idGroup == this.idBreadcrumbGroup)
    }
  }
  popupAnimation = {
    show: {
      type: 'slide', // Tipo di effetto
      duration: 600, // Durata in millisecondi
      from: 0, // Stato iniziale (trasparenza 0)
      to: 1 // Stato finale (trasparenza 100%)
    },
    hide: {
      type: 'slide', // Tipo di effetto per la chiusura
      duration: 300, // Durata in millisecondi
      from: { top: 0 }, // Inizio scorrimento dall'alto
      to: { top: -50 } // Fine scorrimento verso l'alto
    }
  };


}

